// import { Paper } from "@material-ui/core";
// import { Group, Event, Description } from "@material-ui/icons";
// import DynamicFeedRoundedIcon from "@mui/icons-material/DynamicFeedRounded";
// import "../../../../Assets/css/Community/MyfeedInfo.css";
// import { useNavigate } from "react-router-dom";

// const MyfeedInfo = ({ setIsProfile }) => {
//   const navigate = useNavigate();

//   const handleTabNavigation = (tabKey, isProfile = false) => {
//     // If setIsProfile is not a function, just handle navigation
//     // if (typeof setIsProfile === "function") {
//     setIsProfile(true);
//     // } else {
//     //   console.warn("setIsProfile is not a function");
//     // }
//     navigate(`/my-feeds?tab=${tabKey}`);
//   };

//   return (
//     <div className="myfeed-info-container">
//       <Paper className="myfeed-container">
//         <div
//           className="myfeed-section"
//           onClick={() => handleTabNavigation("second", false)}
//         >
//           <DynamicFeedRoundedIcon className="myfeed-icon" />
//           <span>My Posts</span>
//         </div>
//         <div
//           className="myfeed-section"
//           onClick={() => handleTabNavigation("third", true)}
//         >
//           <Group className="myfeed-icon" />
//           <span>My Communities</span>
//         </div>
//         <div
//           className="myfeed-section"
//           onClick={() => handleTabNavigation("fourth", false)}
//         >
//           <Event className="myfeed-icon" />
//           <span>My Events</span>
//         </div>
//         <div
//           className="myfeed-section"
//           onClick={() => handleTabNavigation("fifth", false)}
//         >
//           <Description className="myfeed-icon" />
//           <span>My Blogs</span>
//         </div>
//       </Paper>
//     </div>
//   );
// };

// export default MyfeedInfo;

import { Paper } from "@material-ui/core";
import { Group, Event, Description } from "@material-ui/icons";
import DynamicFeedRoundedIcon from "@mui/icons-material/DynamicFeedRounded";
import "../../../../Assets/css/Community/MyfeedInfo.css";
import { useNavigate } from "react-router-dom";

const MyfeedInfo = () => {
  const navigate = useNavigate();

  const handleTabNavigation = (tabKey) => {
    navigate(`/my-feeds?tab=${tabKey}`);
  };

  return (
    <div className="myfeed-info-container">
      <Paper className="myfeed-container">
        <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("second")}
        >
          <DynamicFeedRoundedIcon className="myfeed-icon" />
          <span>My Feeds</span>
        </div>
        <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("third")}
        >
          <Group className="myfeed-icon" />
          <span>My Communities</span>
        </div>
        <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("fourth")}
        >
          <Event className="myfeed-icon" />
          <span>My Events</span>
        </div>
        <div
          className="myfeed-section"
          onClick={() => handleTabNavigation("fifth")}
        >
          <Description className="myfeed-icon" />
          <span>My Blogs</span>
        </div>
      </Paper>
    </div>
  );
};

export default MyfeedInfo;

